import { createContext } from 'react';

export const MoreDetailDepthContext = createContext(false);
